import { lazy } from 'react'

import { PATH_FEATURES } from 'config/paths'

export const PaymentLinkRoutes = [
    {
        id: 1,
        module: 'payment-link',
        protected: true,
        exact: true,
        path: PATH_FEATURES.paymentLink.root,
        component: lazy(
            () => import('containers/dashboard/features/billing/PaymentLinks'),
        ),
    },
    {
        id: 2,
        module: 'payment-link',
        protected: true,
        exact: true,
        path: `${PATH_FEATURES.paymentLink.create}`,
        component: lazy(
            () =>
                import(
                    // eslint-disable-next-line max-len
                    'containers/dashboard/features/billing/CreateLinks'
                ),
        ),
    },
    {
        id: 3,
        module: 'payment-link',
        protected: true,
        exact: true,
        path: `${PATH_FEATURES.paymentLink.edit}/:id`,
        component: lazy(
            () => import('containers/dashboard/features/billing/EditLinks'),
        ),
    },
]
